<template>
    <div class="o-form" v-if="edit!=false">
        <hr>

        <div class="step1" v-if="step==1">
            <h2 class="o-title-1">
                Étape 1
            </h2>
            <div class="o-grid o-formulaire__item">
                <div class="o-grid-6">
                    <label for="" class="o-label">
                        ISBN du livre
                        <div class="o-spacer-xs"></div>
                        <input type="text" v-model="edit.livre.isbn" class="o-input" required>
                    </label>
                    <small>Veuillez entrer le ISBN de livre de la séance de décicace.</small>
                </div>
            </div>
            <div class="o-spacer"></div>
            <div class="o-button__container">
                <button @click="searchISBN()" class="o-btn o-table-btn ">
                    Suivant
                </button>
            </div>
        </div>

        <div class="step2" v-if="step==2">
            <h2 class="o-title-1">
                Étape 2
            </h2>
            <div class="o-grid o-formulaire__item">
                <div class="o-grid-12">
                    <label for="" class="o-label">
                        Choisir un des auteurs
                        <div class="o-spacer-xs"></div>
                        <div class="o-select__wrap">
                            <select v-model="selectedContributor" class="o-select">
                                <option value="" disabled selected>Sélectionnez dans la liste déroulante</option>
                                <option v-for="contributor in contributors" :value="contributor">{{ contributor.person.name }}</option>
                            </select>
                        </div>
                    </label>
                    <small>Veuillez choisir l'auteur présent pour la séance de décicace.</small>
                </div>
            </div>
            <div class="o-spacer"></div>
            <div class="o-button__container">
                <button @click="fillContributor()" class="o-btn o-table-btn ">
                    Suivant
                </button>
            </div>
        </div>

        <div class="step3" v-if="step==3">
            <h2 class="o-title-1">
                Étape 3
            </h2>
            <h3 class="o-title-2">
                Auteur.e
            </h3>
            <div class="o-grid o-formulaire__item">
                <div class="o-grid-6">
                    <label for="" class="o-label">
                        Prénom
                        <div class="o-spacer-xs"></div>
                        <input type="text" v-model="edit.auteur.firstname" @keyup="searchAuteur" class="o-input">
                    </label>
                </div>

                <div class="o-grid-6">
                    <label for="" class="o-label">
                        Nom
                        <div class="o-spacer-xs"></div>
                        <input type="text" v-model="edit.auteur.lastname" @keyup="searchAuteur" class="o-input">
                    </label>
                </div>
            </div>
            <div class="o-spacer"></div>
            <div class="o-grid">
                <div class="o-grid-6">
                    Photo de l'auteur.e
                    <div class="o-spacer-xs"></div>
                    <img v-if="edit.auteur.photo" :src="edit.auteur.photo.url" alt="">
                    <input type="file" @change="onFileChanged" data-type="photo">
                    <small>Fichier de moins de 5mo si possible</small>
                </div>
                <div class="o-grid-6">
                    Couverture du Livre
                    <div class="o-spacer-xs"></div>
                    <img v-if="edit.livre.couverture" :src="edit.livre.couverture.url" alt="">
                    <input type="file" @change="onFileChanged" data-type="cover">
                    <small>Fichier de moins de 5mo si possible</small>
                </div>
            </div>
            <div class="o-spacer"></div>
            <div class="o-grid">
                <div class="o-grid-12">
                    <label for="" class="o-label">
                        Titre (pour l’accréditation)
                        <div class="o-spacer-xs"></div>
                        <div class="o-select__wrap">
                            <select v-model="edit.auteur.titre" class="o-select">
                                <option value="" disabled selected>Sélectionnez dans la liste déroulante</option>
                                <option value="Auteur">Auteur</option>
                                <option value="Auteure">Auteure</option>
                                <option value="Autrice">Autrice</option>
                                <option value="Illustrateur">Illustrateur</option>
                                <option value="Illustratrice">Illustratrice</option>
                            </select>
                        </div>
                    </label>
                </div>
                <div class="o-grid-12">
                    <label for="" class="o-label">
                        Courte notice biographique
                        <div class="o-spacer-xs"></div>
                        <textarea v-model="edit.auteur.bio" class="o-input"></textarea>
                    </label>
                </div>
                <div class="o-grid-4">
                    <label for="" class="o-label">
                        Maison d'édition
                        <div class="o-spacer-xs"></div>
                        <input type="text" v-model="edit.livre.maison.title" @keyup="searchMaison" class="o-input">
                    </label>
                </div>
                <div class="o-grid-4">
                    <div class="o-label">
                        Logo de la maison d'édition
                    </div>
                    <div class="o-spacer-xs"></div>
                    <img v-if="edit.livre.maison.thumbnail" :src="edit.livre.maison.thumbnail.url" alt="">
                    <input type="file" @change="onFileChanged" data-type="logo">
                </div>
                <div class="o-grid-4">
                    <label for="" class="o-label">
                        Numéro de stand
                        <div class="o-spacer-xs"></div>
                        <div class="o-select__wrap">
                            <select v-model="edit.stand_id" class="o-select">
                                <option value="" disabled selected>Sélectionnez dans la liste déroulante</option>
                                <option v-for="(stand, i) in stands" :value="stand.id">{{ stand.no }}</option>
                            </select>
                        </div>
                    </label>
                </div>
                <div class="o-grid-12">
                    <label for="" class="o-label">
                        Description de la maison d'édition
                        <div class="o-spacer-xs"></div>
                        <textarea class="o-input" v-model="edit.livre.maison.desc"></textarea>
                    </label>
                    <small style="color: red;">(Pour la page de présentation de la maison d'édition sur notre site internet. Remplir une seule fois.)</small>
                </div>
                <div class="o-grid-6">
                    <label for="" class="o-label">
                        Titre du livre
                        <div class="o-spacer-xs"></div>
                        <input type="text" v-model="edit.livre.title" @keyup="searchLivre" class="o-input">
                    </label>
                </div>
                <div class="o-grid-6">
                    <label for="" class="o-label">
                        ISBN du livre
                        <div class="o-spacer-xs"></div>
                        <input type="text" v-model="edit.livre.isbn" class="o-input" required>
                    </label>
                </div>
                <div class="o-grid-6">
                    <label for="" class="o-label">
                        Genre littéraire #1
                        <div class="o-spacer-xs"></div>
                        <div class="o-spacer-xs"></div>
                        <!-- <input type="text" v-model="edit.genre" class="o-input"> -->
                        <div class="o-select__wrap">
                            <select v-model="edit.livre.genre" class="o-select">
                                <option value="" disabled selected>Sélectionnez dans la liste déroulante</option>
                                <option v-for="(genre, i) in genres" :value="genre.term_id">{{ genre.name }}</option>
                            </select>
                        </div>
                    </label>
                </div>
                <div class="o-grid-6">
                    <label for="" class="o-label">
                        Genre littéraire #2
                        <div class="o-spacer-xs"></div>
                        <div class="o-spacer-xs"></div>
                        <!-- <input type="text" v-model="edit.genre" class="o-input"> -->
                        <div class="o-select__wrap">
                            <select v-model="edit.livre.genre2" class="o-select">
                                <option value="" disabled selected>Sélectionnez dans la liste déroulante</option>
                                <option v-for="(genre, i) in genres" :value="genre.term_id">{{ genre.name }}</option>
                            </select>
                        </div>
                    </label>
                </div>
                <div class="o-grid-12">
                    <label for="" class="o-label">
                        Blogue ou site web de l'auteur (sans http://)
                        <div class="o-spacer-xs"></div>
                        <input type="text" v-model="edit.auteur.web" class="o-input">
                    </label>
                </div>
            </div>
            <div class="o-spacer"></div>
            <div class="o-grid">
                <div class="o-grid-12">
                    <div class="o-label">
                        L’auteur.e est-il (elle)  originaire ou habite-t-il (elle) la Mauricie ou le Centre-du-Québec?
                    </div>
                    <div class="o-spacer-xs"></div>
                    <div class="o-button__container">
                        <div class="o-checkbox__wrap">
                            <input type="checkbox" v-model="edit.auteur.originaire" value="Mauricie" class="o-checkbox" id="checkbox-mauricie" onfocus="this.blur()">
                            <label for="checkbox-mauricie" class="o-checkbox-label">
                                Mauricie
                            </label>
                        </div>
                        <div class="o-checkbox__wrap">
                            <input type="checkbox" v-model="edit.auteur.originaire" value="Centre-du-Québec" class="o-checkbox" id="checkbox-quebec" onfocus="this.blur()">
                            <label for="checkbox-quebec" class="o-checkbox-label">
                                Centre-du-Québec
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="o-spacer"></div>
            <div class="o-grid">
                <div class="o-grid-12">
                    <div class="o-label">
                        Cochez s'il s'agit d'un.e :
                    </div>
                    <div class="o-spacer-xs"></div>
                    <div class="o-button__container">
                        <div class="o-checkbox__wrap">
                            <input type="checkbox" v-model="edit.auteur.jeunesse" class="o-checkbox" id="checkbox-jeunesse" value="1" onfocus="this.blur()">
                            <label for="checkbox-jeunesse" class="o-checkbox-label">
                                Auteur.e jeunesse
                            </label>
                        </div>
                        <div class="o-checkbox__wrap">
                            <input type="checkbox" v-model="edit.auteur.illustration" class="o-checkbox" id="checkbox-illustration" value="1" onfocus="this.blur()">
                            <label for="checkbox-illustration" class="o-checkbox-label">
                                Illustrateur.rice
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="o-spacer"></div>
            <div class="">
                <table class="o-table o-table-seances">
                    <thead>
                        <tr>
                            <th v-for="(date, i) in dates"><span>{{ date.name }}</span><br>{{ date.label }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="edit.seances" v-for="i in [0,1,2]">
                            <td v-for="(date, di) in dates">
                                <span class="u-hide-over-sm o-label">
                                    {{ date.name }}<br>{{ date.label }}
                                    <div class="o-spacer-xs"></div>
                                </span>
                                <span class="o-table-formulaire__spanmobile">
                                    <!-- <span class="o-table-formulaire__headmobile">{{ date.label }}</span> -->
                                    <select style="" v-model="edit.seances[date.date][i][0]">
                                        <option value=""></option>
                                        <option v-for="hour in dateHoursFirst(di)" :value="hour">{{ hour }}</option>
                                    </select>
    
                                &nbsp;à&nbsp;
    
                                    <select style="" v-model="edit.seances[date.date][i][1]">
                                        <option value=""></option>
                                        <option v-for="hour in dateHoursLast(di)" :value="hour">{{ hour }}</option>
                                    </select>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="o-spacer"></div>
            <div class="o-button__container">
                <button @click="cancel" class="o-btn o-table-btn">
                    <svg aria-hidden="true" focusable="false" class="o-ico">
                        <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=2024#cancel"></use>
                    </svg>
                    Annuler
                </button>
                <button @click="save(edit)" class="o-btn o-table-btn ">
                    <svg aria-hidden="true" focusable="false" class="o-ico">
                        <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=2024#save"></use>
                    </svg>
                    Sauvegarder
                </button>
            </div>

        </div><!-- end step3 -->
        <hr>
    </div>


    <div>
        <div class="o-spacer"></div>
        <h3 class="o-title-3 -text-no-margin">
            Liste de vos séances de dédicaces
        </h3>
        <div class="o-spacer-sm"></div>
        <div class="">
            <table class="o-table o-table-seances">
                <thead>
                    <tr class="thead">
                        <th class="o-table-th-form">Nom</th>
                        <th class="o-table-th-form">Prénom</th>
                        <th class="o-table-th-form">Livre</th>
                        <th class="o-table-th-form">Maison d'édition</th>
                        <th class="o-table-th-form"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(d, id) in auteurs" v-bind:key="id">
                        <td class="o-table-td-form"><span data-label="Nom" class="o-table-td-form__item">{{ d.auteur.lastname }}</span></td>
                        <td class="o-table-td-form"><span data-label="Prénom" class="o-table-td-form__item">{{ d.auteur.firstname }}</span></td>
                        <td class="o-table-td-form"><span data-label="Livre" class="o-table-td-form__item">{{ d.livre.title }}</span></td>
                        <td class="o-table-td-form"><span data-label="Maison d'édition" class="o-table-td-form__item">{{ d.livre.maison.title }}</span></td>
                        <td class="o-table-td-form">
                            <div class="o-button__container">
                                <button class="o-btn-edit" @click="setEdit(d)">
                                    <svg aria-hidden="true" focusable="false" class="o-ico">
                                        <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=2024#edit"></use>
                                    </svg>
                                    Éditer
                                </button>
                                <button class="o-btn-trash" @click="deleteAuteur(d)">
                                    <svg aria-hidden="true" focusable="false" class="o-ico">
                                        <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=2024#trash"></use>
                                    </svg>
                                    Supprimer
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="o-spacer"></div>
        <div class="o-button__container">
            <button @click="add" class="o-btn o-table-btn">
                <svg aria-hidden="true" focusable="false" class="o-ico">
                    <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=2024#add"></use>
                </svg>
                Nouveau
            </button>
            <a href="/wp/wp-login.php?action=logout" class="o-btn o-table-btn">
                <svg aria-hidden="true" focusable="false" class="o-ico">
                    <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=2024#logout"></use>
                </svg>
                Déconnexion
            </a>
        </div>
    </div>
</template>

<script>
import swal from 'sweetalert2'
import axios from 'axios'

export default {
    name: 'FormulaireDedicace',
    data() {
        return {
            emailButton: 'Recevoir mes dédicaces par courriel',
            auteurs: [],
            edit: [],
            dates: [],
            stands: [],
            genres: [],
            selectedFile: null,
            step: 1,
            contributors: [],
            selectedContributor: null
        }
    },
    created() {
        this.getAuteurs();
        this.searchLivre = this.debounce(this.searchLivre, 1000);
        this.searchAuteur = this.debounce(this.searchAuteur, 1000);
        this.searchMaison = this.debounce(this.searchMaison, 1000);
    },
    methods: {
        setEdit(d) {
            this.edit = d;
            this.step = 3;
        },
        debounce(func, wait, immediate) {
            var timeout;
            return function () {
                var context = this, args = arguments;
                var later = function () {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        },
        searchAuteur() {
            let that = this;
            if (that.edit.auteur.auteur_id==0) {
                axios.get(WPURLS.ajax_url, {
                    params: {
                        action: 'search_auteur',
                        firstname: that.edit.auteur.firstname,
                        lastname: that.edit.auteur.lastname
                    }
                }).then(function (response) {
                    if (response.data.auteurs) {
                        that.alertExisting(response.data.auteurs);
                    }
                })
            }
        },
        searchLivre() {
            let that = this;
            if (that.edit.livre.id==0) {
                axios.get(WPURLS.ajax_url, {
                    params: {
                        action: 'search_livre',
                        title: that.edit.livre.title
                    }
                }).then(function (response) {
                    if (response.data.livres) {
                        that.alertExistingLivre(response.data.livres);
                    }
                })
            }
        },
        searchMaison() {
            let that = this;
            that.edit.livre.maison.id = 0
            axios.get(WPURLS.ajax_url, {
                params: {
                    action: 'search_maison',
                    title: that.edit.livre.maison.title
                }
            }).then(function (response) {
                if (response.data.maisons && response.data.maisons.length) {
                    that.alertExistingMaison(response.data.maisons);
                }
            })
        },
        alertExistingLivre(livres) {
            let that = this;
            let livre = livres.pop();
            let html = '<p>Un livre similaire a été trouvé!</p>';

            if (livre.couverture) {
                html += '<img width="100" src="' + livre.couverture.url + '"><br>';
            }

            html += livre.title + '<br>';

            html += '<p>Est-ce votre livre?</p>';

            swal.fire({
                title: 'Livre existant',
                icon: 'info',
                html: html,
                showCancelButton: true,
                confirmButtonText: 'Oui',
                cancelButtonText: 'Non'
            }).then((result) => {
                if (result.value) {
                    that.edit.livre = livre;
                } else {
                    if (livres.length) that.alertExistingLivre(livres);
                }
            });
        },
        alertExisting(auteurs) {
            if (auteurs.length == 0) return;
            let that = this;
            let auteur = auteurs.pop();
            let html = '<p>Un auteur similaire a été trouvé!</p>';

            if (auteur.photo !== undefined) {
                html += '<img width="100" src="' + auteur.photo.url + '"><br>';
            }

            html += auteur.firstname + ' ' + auteur.lastname + '<br>';

            if (auteur.web) {
                html += auteur.web + '<br>';
            }

            html += '<p>Est-ce votre auteur?</p>';

            swal.fire({
                title: 'Auteur existant',
                icon: 'info',
                html: html,
                showCancelButton: true,
                confirmButtonText: 'Oui',
                cancelButtonText: 'Non'
            }).then((result) => {
                if (result.value) {
                    that.edit.auteur.auteur_id = auteur.auteur_id;
                    that.edit.auteur.titre = auteur.titre;
                    that.edit.auteur.firstname = auteur.firstname;
                    that.edit.auteur.lastname = auteur.lastname;
                    that.edit.auteur.web = auteur.web;
                    that.edit.auteur.originaire = auteur.originaire;
                    that.edit.auteur.jeunesse = auteur.jeunesse;
                    that.edit.auteur.illustration = auteur.illustration;
                    that.edit.auteur.bio = auteur.bio;
                    if (auteur.btlf_id) that.edit.auteur.btlf_id = auteur.btlf_id;
                    if (that.edit.auteur.photo.id == 0 && auteur.photo) that.edit.auteur.photo = auteur.photo;
                } else {
                    if (auteurs.length) that.alertExisting(auteurs);
                }
            });
        },
        alertExistingMaison(maisons) {
            let that = this;
            let maison = maisons.pop();
            let html = '<p>Une maison d\'édition similaire a été trouvée!</p>';

                if (maison.thumbnail) {
                html += '<img width="100" src="' + maison.thumbnail.url + '"><br>';
            }

            html += maison.title + '<br>';

            html += '<p>Est-ce votre maison d\'édition?</p>';

            swal.fire({
                title: 'Maison d\'édition existante',
                icon: 'info',
                html: html,
                showCancelButton: true,
                confirmButtonText: 'Oui',
                cancelButtonText: 'Non'
            }).then((result) => {
                if (result.value) {
                    that.edit.livre.maison.id = maison.maison_id;
                    that.edit.livre.maison.title = maison.title;
                    if (that.edit.livre.maison.thumbnail.id == 0) that.edit.livre.maison.thumbnail = maison.thumbnail;
                    that.edit.livre.maison.desc = maison.desc;
                } else {
                    if (maisons.length) that.alertExistingMaison(maisons);
                }
            });
        },
        onFileChanged(event) {
            console.log(event.target)
            this.onUpload(event.target.files[0], event.target.dataset.type)
        },
        onUpload(file, type) {
            var that = this;
            const formData = new FormData()
            formData.append('myFile', file, file.name)
            formData.append('action', 'upload_auteur_photo')
            axios.post(WPURLS.ajax_url, formData).then(function (response) {
                if (response.data.attachment_id === undefined) {
                    alert('Veuillez réessayer');
                } else {
                    if (type == 'photo') {
                        that.edit.auteur.photo = {
                            id: response.data.attachment_id,
                            url: response.data.previewImage
                        }
                    }
                    if (type == 'cover') {
                        that.edit.livre.couverture = {
                            id: response.data.attachment_id,
                            url: response.data.previewImage
                        }
                    }
                    if (type == 'logo') {
                        that.edit.livre.maison.thumbnail = {
                            id: response.data.attachment_id,
                            url: response.data.previewImage
                        }
                    }
                }
            })
        },
        cancel: function() {
            this.edit = false;
            this.getAuteurs();
        },
        getAuteurs: function() {
            var that = this;
            that.edit = false;
            /*$.get(WPURLS.ajax_url, {action: 'get_auteurs_dedicace'}).done(function(data) {
                that.auteurs = data.auteurs;
                that.dates = data.dates;
                that.stands = data.stands;
                that.genres = data.genres;
            });*/
            fetch(WPURLS.ajax_url + '?action=get_auteurs_dedicace')
                .then(response => response.json())
                .then(data => {
                    that.auteurs = data.auteurs;
                    that.dates = data.dates;
                    that.stands = data.stands;
                    that.genres = data.genres;
                });
        },
        save: function(auteur) {
            var that = this;
            var error = false;
            var message = '';

            /*var fields = [
                ['titre', 'Titre'],
                ['lastname', 'Nom'],
                ['maison', 'Maison d\'édition'],
                ['genre', 'Genre littéraire'],
                ['livre', 'Titre du livre'],
                ['isbn', 'ISBN'],
            ];

            fields.forEach(function (field) {
                if (auteur[field[0]].length === 0) {
                    message += "<br>" + field[1]
                    error = true;
                }
            });*/

            if (error) {
                swal.fire({
                    title: 'Champs obligatoire',
                    icon: 'error',
                    html: message
                })
                return;
            }

            /*$.post(WPURLS.ajax_url, {action: 'save_auteurs_dedicace', auteur: auteur}).done(function(data) {
                that.getAuteurs();
            });*/
            fetch(WPURLS.ajax_url + '?action=save_auteurs_dedicace', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({auteur: auteur})
            })
                .then(response => response.json())
                .then(data => {
                    that.getAuteurs();
                });
        },
        deleteAuteur: function(auteur) {
            var that = this;
            /*$.post(WPURLS.ajax_url, {action: 'delete_auteur_dedicace', auteur: auteur}).done(function(data) {
                that.getAuteurs();
            });*/
            fetch(WPURLS.ajax_url+'?action=delete_auteur_dedicace', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ auteur: auteur})
            })
                .then(response => response.json())
                .then(data => {
                    that.getAuteurs();
                });
        },
        add: function() {
            var that = this;
            var auteur = {
                auteur: {
                    auteur_id: 0,
                    titre: '',
                    firstname: '',
                    lastname: '',
                    photo: {
                        id: 0,
                        url: ''
                    },
                    originaire: [],
                    jeunesse: false,
                    illustration: false,
                    bio: ''
                },
                livre: {
                    id: 0,
                    title: '',
                    couverture: {
                        id: 0,
                        url: ''
                    },
                    genre: '',
                    genre2: '',
                    isbn: '',
                    maison: {
                        id: 0,
                        title: '',
                        desc: '',
                        thumbnail: {
                            id: 0,
                            url: ''
                        }
                    },

                },
                stand_id: 0,
                seances: {}
            }

            that.dates.forEach(date => {
                auteur.seances[date.date] = [ ['',''], ['',''], ['',''] ]
            });

            that.auteurs.push(auteur);
            that.edit = that.auteurs[that.auteurs.length-1];
            that.step = 1;
        },
        email: function() {
            let app = this;
            /*$.get(WPURLS.ajax_url, { action: 'send_email_dedicaces' }).done(function (data) {
                app.emailButton = 'Envoyé!';
            });*/
            fetch(WPURLS.ajax_url + '?action=send_email_dedicaces')
                .then(response => response.json())
                .then(data => {
                    app.emailButton = 'Envoyé!';
                });
        },
        dateHoursFirst: function(i) {
            let hours = [];
            let start = i < 2 ? 9 : 10;
            let end = i < 3 ? 21 : 17;
            /*if (i == 2) {
                end = 20;
            }*/

            for (let i=start; i<end; i++) {
                ['00','15','30','45'].forEach(function(min) {
                    hours.push(i+' h ' +min);
                });
            }

            return hours;
        },
        dateHoursLast: function(i) {
            let hours = [];
            let start = i < 2 ? 9 : 10;
            let end = i < 3 ? 21 : 17;
            /*if (i == 2) {
                end = 20;
            }*/

            for (let i=start; i<=end; i++) {
                ['00','15','30','45'].forEach(function(min) {
                    if (i==start && min=='00') return;
                    if (i==end && min!='00') return;
                    hours.push(i+' h ' +min);
                });
            }

            return hours;
        },
        searchISBN() {
            let isbn = this.edit.livre.isbn;
            let url = WPURLS.ajax_url + '?action=get_isbn&isbn=' + isbn;

            fetch (url)
                .then(response => response.json())
                .then(data => {
                    console.log(data);

                    if (data === []) {
                        this.step = 3;
                    }

                    if (data.title) {
                        this.edit.livre.title = data.title;
                        this.edit.livre.resume = data.summary;

                        if (data.cover) {
                            this.edit.livre.couverture = {
                                id: 0,
                                url: data.cover.url
                            }
                        }
                        if (data.publisher) {
                            this.edit.livre.maison = {
                                id: 0,
                                title: data.publisher.name,
                                desc: data.publisher.description
                            }

                            if (data.publisher.logo) {
                                this.edit.livre.maison.thumbnail = {
                                    id: 0,
                                    url: data.publisher.logo.url
                                }
                            }
                        }

                        if (data.contributors.length == 1) {
                            this.edit.auteur.firstname = data.contributors[0].person.first_name;
                            this.edit.auteur.lastname = data.contributors[0].person.last_name;
                            this.edit.auteur.btlf_id = data.contributors[0].person.btlf_id;
                            this.edit.auteur.bio = data.contributors[0].person.bio;
                            this.edit.auteur.web = data.contributors[0].person.website;

                            if (data.contributors[0].person.photo) {
                                this.edit.auteur.photo = {
                                    id: 0,
                                    url: data.contributors[0].person.photo.url
                                }
                            }
                            this.step = 3;
                        }else if (data.contributors.length > 1) {
                            this.contributors = data.contributors;
                            this.step = 2;
                        } else {
                            this.step = 3;
                        }
                    } else {
                        this.step = 3;
                    }
                });
        },
        fillContributor() {
            this.edit.auteur.firstname = this.selectedContributor.person.first_name;
            this.edit.auteur.lastname = this.selectedContributor.person.last_name;
            this.edit.auteur.btlf_id = this.selectedContributor.person.btlf_id;
            this.edit.auteur.bio = this.selectedContributor.person.bio;
            this.edit.auteur.web = this.selectedContributor.person.website;

            if (this.selectedContributor.person.photo) {
                this.edit.auteur.photo = {
                    id: 0,
                    url: this.selectedContributor.person.photo.url
                }
            }

            this.step = 3;
        }
    }
}
</script>
